module.exports = __webpack_public_path__ + "img/picc.3338b581.png";